const LIST_PATH = "/entities";

export const entityPaths = {
  list: LIST_PATH,
  detail: id => `${LIST_PATH}/${id}`,
  edit: id => `${LIST_PATH}/${id}/edit`,
  create: () => `${LIST_PATH}/new`,
};
